import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouteState, selectRouteState } from '@state/route';
import { ServiceRequest } from 'src/app/models/service-request';
import { ServiceRequestState } from './service-request.state';

export const selectServiceRequestState =
  createFeatureSelector<ServiceRequestState>('serviceRequest');

export const selectServiceRequests = createSelector(
  selectServiceRequestState,
  (state: ServiceRequestState) => state.serviceRequests
);

export const selectCurrentServiceRequest = createSelector(
  selectServiceRequests,
  selectRouteState,
  (serviceRequests: ServiceRequest[], route: RouteState) => {
    return serviceRequests.find(
      (x) => x.id === route.params['serviceRequestId']
    );
  }
);

export const selectServiceRequestsFetchedAt = createSelector(
  selectServiceRequestState,
  (state: ServiceRequestState) => state.fetchedAt
);
